import React from 'react'
import { TableHeader, TableLoader } from '../../commons';
import StatementTableData from '../Grouping/DetailedBalanceSheet';
import { currencySignAndNegativeValueAdjust } from '../../../utils/commonFunctions';

export const tableHeader=[{
    label: 'Ledger name',
    value: 'ledger_name',
    checked: true,
    defaultChecked: true
},{
    label: 'Closing amount',
    value: 'closing_amount',
    checked: true,
    defaultChecked: true
}]

type AppProps={
    data:any;
    total:number;
    currencySign: string | undefined;
    fetching:boolean;
    subHeader:string;
    endDate:string;
    finalRedirectLink:{ pathname: string};
}
const  BalanceSheetTable = ({
    data,
    total,
    fetching,
    currencySign,
    subHeader,
    finalRedirectLink,
    endDate
}:AppProps) => {
    const renderBody=()=>{
        let finalData=data?.map((singleData:any,index:number)=>{
            return <StatementTableData
            endDate={endDate}
            singleData={singleData} 
            count={1}
            subHeader={subHeader}  
            index={index + 1}
            currencySign={currencySign}
            finalRedirectLink={finalRedirectLink}
            />
           })
           return finalData
    }

    const renderFooter=()=>{
        let finalData=tableHeader?.map((thead: any) => {
            if (thead?.value === "ledger_name") {
                return <td style={{borderTop:"none"}}><p className={'reports-total'}>TOTAL INCOME</p></td>
            }
            if (thead?.value === "closing_amount") {
                return <td style={{borderTop:"none"}}><p className={'reports-total'}>{currencySignAndNegativeValueAdjust(currencySign,total?total?.toString():"0")}</p></td>
            }
        })
        return finalData
    }

    const renderHeader=()=>{
       return <th style={{backgroundColor:"#e8ecf0",border:"none",borderRadius:"0px",color:"#6e7491",fontWeight:600,fontSize:"14px"}}>{subHeader}</th>
    }

    return (
        <>
       { fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={8}
        /> :
        <div className='grouping'>
           <table className='table table-bordered' >
             <thead>
             {renderHeader()}
             <th style={{backgroundColor:"#e8ecf0",border:"none",borderRadius:"0px"}}></th>
             </thead>
            <thead className='sticky-table-header' >
                <TableHeader tableHeader={tableHeader} />
            </thead>
            <tbody>
                {renderBody()}
            </tbody>
            <tfoot>
                {renderFooter()}
            </tfoot>
        </table>
        </div>
        }
        </>
     
    )
}

export default BalanceSheetTable